module.exports = __webpack_public_path__ + "i18n/ja.44b9b7e16d98dfc8faccbe6fcaf5d40e.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1000
// module chunks = 60